import { useMemo } from 'react';
import { useSyncExternalStore } from 'react';

const SEARCH_PARAMS_CHANGE_EVENT = 'search-params-readonly:change';

let historyPatched = false;

function patchHistory() {
  if (historyPatched || typeof window === 'undefined') {
    return;
  }

  historyPatched = true;

  const notify = () => {
    window.dispatchEvent(new Event(SEARCH_PARAMS_CHANGE_EVENT));
  };

  const originalPushState = window.history.pushState;
  const originalReplaceState = window.history.replaceState;

  window.history.pushState = function (...args) {
    const result = originalPushState.apply(this, args);
    notify();
    return result;
  };

  window.history.replaceState = function (...args) {
    const result = originalReplaceState.apply(this, args);
    notify();
    return result;
  };
}

function subscribe(onStoreChange: () => void) {
  if (typeof window === 'undefined') {
    return () => {};
  }

  patchHistory();

  window.addEventListener('popstate', onStoreChange);
  window.addEventListener(SEARCH_PARAMS_CHANGE_EVENT, onStoreChange);

  return () => {
    window.removeEventListener('popstate', onStoreChange);
    window.removeEventListener(SEARCH_PARAMS_CHANGE_EVENT, onStoreChange);
  };
}

function getSnapshot() {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.location.search;
}

export function useRouterlessSearchParams(): URLSearchParams {
  const search = useSyncExternalStore(subscribe, getSnapshot, () => '');
  return useMemo(() => new URLSearchParams(search), [search]);
}
